import { render, staticRenderFns } from "./comp-accout.vue?vue&type=template&id=5a31e6b6&"
import script from "./comp-accout.vue?vue&type=script&lang=js&"
export * from "./comp-accout.vue?vue&type=script&lang=js&"
import style0 from "./comp-accout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports